import { SVGProps } from "react";

export function Market({ className }: SVGProps<SVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_519_19327)">
        <path
          d="M9.19258 3.7041H2.45148C2.18555 3.7041 1.96997 3.91967 1.96997 4.18561V10.4452C1.96997 10.7111 2.18555 10.9267 2.45148 10.9267H9.19258C9.45852 10.9267 9.67409 10.7111 9.67409 10.4452V4.18561C9.67409 3.91967 9.45852 3.7041 9.19258 3.7041Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.963015"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.13678 4.66694V2.98166C4.13678 2.05091 4.8913 1.29639 5.82206 1.29639C6.75281 1.29639 7.50733 2.05091 7.50733 2.98166V4.66694"
          stroke="currentColor"
          strokeWidth="0.963015"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_19327">
          <rect
            width="11.5562"
            height="11.5562"
            fill="white"
            transform="translate(0.0439453 0.333496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
